import { SuperAdminConstants } from '../../../_constants';

const initialState = { deleteOrgDetailsLoading: true, data: '', error: false };

export function deleteOrgDetailsReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ORG_DETAILS:
            return {
                deleteOrgDetailsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ORG_DETAILS:
            return {
                deleteOrgDetailsLoading: false,
                data: action.deleteOrgDetails,
                error: false
            };
        case SuperAdminConstants.GET_ORG_DETAILS_ERROR:
            return {
                deleteOrgDetailsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/OrgDetails/deleteOrgDetails.reducer.js